module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFixFooter),
      expression: "showFixFooter"
    }],
    staticClass: "tfooter"
  }, [_c('div', {
    staticClass: "up"
  }, _vm._l((_vm.infos), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "infos"
    }, [_c('span', {
      staticClass: "geekbang-icon",
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_vm._v(_vm._s(item.word))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143e01c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/footer.vue
// module id = 440
// module chunks = 1